import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User } from "lucide-react";

/**
 * v2.6.9 batch BB · Customer info capture for driver-side trip flows
 * (City Taxi · Custom Trip · Live Meter). Stored on the trip doc so
 * dispatch/admin can pull contact info later. All fields optional —
 * driver fills what they have time to collect.
 *
 * Shape:
 *   value = { first_name, last_name, phone, email, address }
 */
export default function CustomerInfoForm({ value, onChange, testidPrefix = "cust", className = "" }) {
  const v = value || {};
  const set = (k) => (e) => onChange?.({ ...v, [k]: e.target.value });

  return (
    <Card className={`bg-zinc-900 border-zinc-800 p-5 ${className}`} data-testid={`${testidPrefix}-info-card`}>
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-lg bg-amber-400/10 border border-amber-400/30 flex items-center justify-center text-amber-400">
          <User className="h-5 w-5" />
        </div>
        <div>
          <h3 className="text-sm font-bold text-zinc-200">Customer Information</h3>
          <p className="text-[11px] text-zinc-500">Captured on the trip record for receipts & follow-up</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-zinc-400">First Name</Label>
          <Input
            data-testid={`${testidPrefix}-first-name`}
            value={v.first_name || ""}
            onChange={set("first_name")}
            placeholder="First name"
            className="bg-zinc-950 border-zinc-700 h-10 mt-1"
          />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-zinc-400">Last Name</Label>
          <Input
            data-testid={`${testidPrefix}-last-name`}
            value={v.last_name || ""}
            onChange={set("last_name")}
            placeholder="Last name"
            className="bg-zinc-950 border-zinc-700 h-10 mt-1"
          />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-[10px] uppercase tracking-wider text-zinc-400">Address</Label>
          <Input
            data-testid={`${testidPrefix}-address`}
            value={v.address || ""}
            onChange={set("address")}
            placeholder="Street address, city, state"
            className="bg-zinc-950 border-zinc-700 h-10 mt-1"
          />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-zinc-400">Phone</Label>
          <Input
            data-testid={`${testidPrefix}-phone`}
            value={v.phone || ""}
            onChange={set("phone")}
            placeholder="(580) 555-0100"
            inputMode="tel"
            className="bg-zinc-950 border-zinc-700 h-10 mt-1"
          />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-zinc-400">Email</Label>
          <Input
            data-testid={`${testidPrefix}-email`}
            value={v.email || ""}
            onChange={set("email")}
            placeholder="rider@example.com"
            inputMode="email"
            type="email"
            className="bg-zinc-950 border-zinc-700 h-10 mt-1"
          />
        </div>
      </div>
    </Card>
  );
}
